import { atom, useRecoilState } from 'recoil';
import { PainPart } from '../types';

const $dashboardChartFormPainPartsState = atom<PainPart[]>({
  key: 'dashboardChartFormPainPartsState',
  default: []
});

export const useDashboardChartFormPainPartsState = () => {
  const [dashboarChartFormPainParts, setDashboardChartFormPainParts] =
    useRecoilState($dashboardChartFormPainPartsState);

  return {
    dashboarChartFormPainParts,
    setDashboardChartFormPainParts
  };
};
